/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Work_0_DescInputs */

const en_svc_ai_integration_work_0_desc = /** @type {(inputs: Svc_Ai_Integration_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every lesson plan and answer streams through a RAG pipeline over the curriculum, with layered prompts tuned per user level.`)
};

const ar_svc_ai_integration_work_0_desc = /** @type {(inputs: Svc_Ai_Integration_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل خطة درس وإجابة تُبث عبر خط أنابيب RAG فوق المنهج، مع برومبتات متعددة الطبقات مضبوطة لكل مستوى مستخدم.`)
};

const bn_svc_ai_integration_work_0_desc = /** @type {(inputs: Svc_Ai_Integration_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতিটি লেসন প্ল্যান ও উত্তর কারিকুলামের উপর RAG পাইপলাইনের মাধ্যমে স্ট্রিম হয়, প্রতি ইউজার লেভেলে লেয়ারড প্রম্পটসহ।`)
};

const de_svc_ai_integration_work_0_desc = /** @type {(inputs: Svc_Ai_Integration_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Unterrichtsplan und jede Antwort fließt durch eine RAG-Pipeline über den Lehrplan, mit mehrschichtigen Prompts, abgestimmt auf jedes Nutzerlevel.`)
};

const es_svc_ai_integration_work_0_desc = /** @type {(inputs: Svc_Ai_Integration_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada plan de lección y respuesta se transmite por un pipeline RAG sobre el plan de estudios, con prompts por capas ajustados por nivel de usuario.`)
};

const fr_svc_ai_integration_work_0_desc = /** @type {(inputs: Svc_Ai_Integration_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque plan de cours et chaque réponse sont diffusés via un pipeline RAG tout au long du programme, avec des prompts multicouches adaptés à chaque niveau d'utilisateur.`)
};

const pt_svc_ai_integration_work_0_desc = /** @type {(inputs: Svc_Ai_Integration_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada plano de aula e resposta são transmitidos por meio de um pipeline RAG ao longo do currículo, com prompts em camadas ajustados por nível de usuário.`)
};

const zh_svc_ai_integration_work_0_desc = /** @type {(inputs: Svc_Ai_Integration_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每份课程计划和回答都经过课程 RAG 管道，按用户级别配好分层提示词再流式输出。`)
};

const tr_svc_ai_integration_work_0_desc = /** @type {(inputs: Svc_Ai_Integration_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her ders planı ve yanıtı, kullanıcı seviyesine ayarlı katmanlı prompt'larla müfredat üstünden bir RAG hattından akar.`)
};

const ru_svc_ai_integration_work_0_desc = /** @type {(inputs: Svc_Ai_Integration_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каждый план урока и ответ стримятся через RAG-пайплайн поверх программы, с многоуровневыми промптами под каждый уровень юзера.`)
};

const pl_svc_ai_integration_work_0_desc = /** @type {(inputs: Svc_Ai_Integration_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każdy plan lekcji i odpowiedź płyną pipelinem RAG po programie, z warstwowymi promptami dostrojonymi pod poziom użytkownika.`)
};

/**
* | output |
* | --- |
* | "Every lesson plan and answer streams through a RAG pipeline over the curriculum, with layered prompts tuned per user level." |
*
* @param {Svc_Ai_Integration_Work_0_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_work_0_desc = /** @type {((inputs?: Svc_Ai_Integration_Work_0_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Work_0_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_work_0_desc(inputs)
	if (locale === "bn") return bn_svc_ai_integration_work_0_desc(inputs)
	if (locale === "de") return de_svc_ai_integration_work_0_desc(inputs)
	if (locale === "es") return es_svc_ai_integration_work_0_desc(inputs)
	if (locale === "fr") return fr_svc_ai_integration_work_0_desc(inputs)
	if (locale === "pt") return pt_svc_ai_integration_work_0_desc(inputs)
	if (locale === "zh") return zh_svc_ai_integration_work_0_desc(inputs)
	if (locale === "tr") return tr_svc_ai_integration_work_0_desc(inputs)
	if (locale === "ru") return ru_svc_ai_integration_work_0_desc(inputs)
	if (locale === "pl") return pl_svc_ai_integration_work_0_desc(inputs)
	return en_svc_ai_integration_work_0_desc(inputs)
});
export { svc_ai_integration_work_0_desc as "svc_ai-integration_work_0_desc" }